module.exports = "/_next/static/images/31ba8a5507a7a26dbdde44d5e0e21ac7-row-2-with.svg";